<template>
  <div class="match__list">
    <div class="match__box user-dice" :class="isActive">
      <div class="match__item">
        <p class="match__text">あなたのサイコロ</p>
        <vue-audio :file="3" ref="clickBtn"></vue-audio>
        <button class="btn" :class="btnStart" @click="shakeDice"><span><img class="txt_stop_race" src="../assets/image/txt_stop_raceScreen.png" alt="" v-show="!isStart"><img src="../assets/image/txt_match.png" alt="" v-show="isStart"></span><span></span></button>
      </div>
      <div class="match__item">
        <dice id="userDiceL"></dice>
        <dice id="userDiceS"></dice>
      </div>
    </div>
    <div class="match__box pc-dice" :class="pcDiceStatus && !showRaceTextGoal ? 'active' : ''">
      <div class="match__item">
        <p class="match__text">対戦相手のサイコロ</p>
      </div>
      <div class="match__item">
        <dice id="pcDiceL"></dice>
        <dice id="pcDiceS"></dice>
      </div>
    </div>
  </div>
</template>
<script>
  import { store } from '../store/store'
  import Dice from './Dice.vue'
  import Audio from './Audio'
  export default {
    name: 'MatchDice',
    data () {
      return {
        diceRun: '',
        isSelected: false,
        btnStart: 'btn__match inactive',
        isStart: true
      }
    },
    components: {
      'dice': Dice,
      'vue-audio': Audio
    },
    computed: {
      pcDiceStatus () {
        return store.state.pcDiceStatus
      },
      showRaceTextGoal () {
        return store.state.showRaceTextGoal
      },
      showRaceTextStart () {
        return store.state.showRaceTextStart
      },
      isActive () {
        if (!this.pcDiceStatus && !this.showRaceTextGoal && !this.showRaceTextStart) {
          this.btnStart = 'btn__match'
          return 'active'
        } else {
          return ''
        }
      }
    },
    methods: {
      shakeDice () {
        // Play audio button click
        this.$refs.clickBtn.play()
        this.isSelected = !this.isSelected
        if (this.isSelected) {
          this.btnStart = 'btn__select__stop inactive'
          this.isStart = false
          setTimeout(() => { this.btnStart = 'btn__select__stop' }, 700)
        } else {
          this.btnStart = 'btn__match inactive'
          this.isStart = true
        }
        store.dispatch('setDiceRun', {
          'currentDice': 'user',
          'diceStatus': this.isSelected
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// MatchDice.vue?5aed5b45